// src/pages/SpiritsPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import spiritsBackground from '../assets/images/spirits-background.jpg';
import '../styles/spirits.css';

const SpiritsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="spirits-page" style={{ backgroundImage: `url(${spiritsBackground})` }}>
      <Header 
        title="Spiritueux" 
        showBackButton={true} 
        onBackClick={() => navigate('/prototype-categories')}
      />
      
      <div className="spirits-content">
        <div className="spirits-content-overlay">
          <div className="spirits-icon animate-float">
            <svg viewBox="0 0 24 24" className="w-full h-full" fill="currentColor">
              <path d="M3,14L4.5,14.07L8.07,21H12V19L10,19C9.86,19 9.73,18.94 9.63,18.83C9.53,18.73 9.5,18.59 9.5,18.45L10,5.05C10,4.82 10.08,4.6 10.23,4.43C10.38,4.26 10.59,4.16 10.82,4.15C10.85,4.15 10.87,4.15 10.9,4.15C11.13,4.15 11.35,4.24 11.5,4.41C11.67,4.57 11.77,4.78 11.78,5L12,18H14L14.22,5C14.23,4.77 14.33,4.56 14.5,4.39C14.66,4.23 14.88,4.14 15.11,4.14C15.34,4.14 15.56,4.23 15.72,4.39C15.89,4.56 16,4.78 16,5L16,12L18,11L20.06,21H20.5L20.72,20.35L18.85,11.08L20.15,10.37L22,20L22,21H16V19H17.5L16,12V19L16,21H8.93L5.57,14.5L4.5,16.07V21H3V14Z" />
            </svg>
          </div>
          
          <h2 className="spirits-title">Bientôt disponible !</h2>
          
          <p className="spirits-description">
            Notre collection de spiritueux premium arrive bientôt. 
            Whisky, vodka, rhum, gin et autres alcools de qualité 
            seront disponibles pour agrémenter vos soirées et célébrations.
          </p>
          
          <button 
            onClick={() => navigate('/prototype-categories')}
            className="spirits-button"
          >
            <svg className="spirits-button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Retour aux options
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpiritsPage;